import React, { useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import './ads-form.scss'
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import Constant from "../../../Constant";
import { postAd } from '../../../services/transaction-service';

const orderSchema = Yup.object().shape({
  pin: Yup.string()
    .required('PIN is required')
    .min(5, 'PIN must be exactly 5 characters')
    .max(5, "PIN must be exactly 5 characters")
    .matches(
      /^([a-zA-Z0-9]){0,5}/,
      'PIN should be alphanumeric. No special characters allowed'
    ),
    title: Yup.string()
    .required('Ce champs est obligatoire'),
    link: Yup.string()
});

const AdsForm = ({ userId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = (values) => {
    setIsLoading(true);
    postAd(values).then(res => {
      if(res.status_code == 200 || res.status_code == 201) {
        toast(`${res.message}. You can close this page and return to the app`);
        setMessage(`${res.message}. You can close this page and return to the app`);
      }else {
        toast(`Sorry! ${res.message}`);
        setErrorMessage(res.message);
      }
    }).catch(err => {
      toast(`Sorry, ${err.message}`)
      setErrorMessage(err.message);
    }).finally( () => {
      setIsLoading(false);
      setFormSubmitted(true);
    })
  };

  return  (
    <div className="login-form">
      <div className="login-error">{ errorMessage ? errorMessage : ''}</div>
      <div className='login-info'><h2>AFTA WALLET</h2></div>
      { !formSubmitted &&
        <Formik
        initialValues={{
          pin: "",
          title: "",
          link: "",
          id: userId,
        }}
        onSubmit={(values) => {
          // console.log('ad values to be submitted', values);
          handleSubmit(values);
        }}
        validationSchema={orderSchema}
        >
        {({ handleSubmit, values, handleChange, errors, touched }) => (
          <form onSubmit={handleSubmit}>
            
            <div className={`field`}>
              <h3>Remplissez le formulaire pour publier.</h3>
              <p className='text-danger'><strong>$0.40 - Pay per View</strong></p>
              <p className='text-danger'><strong>$0.45 - Pay per Click</strong></p>
            </div>
            <div className={`field`}>
              <label htmlFor="title">Texte publicitaire</label>
              <textarea
                name="title"
                rows={3}
                cols={50}
                id="title"
                placeholder="Ad text"
                value={values.title}
                onChange={handleChange}></textarea>
              {errors.title && touched.title ? (
                <div className="error">{errors.title}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="link">Web Link</label>
              <input
                name="link"
                id="link"
                placeholder="Ad link"
                value={values.link}
                onChange={handleChange} />
              {errors.link && touched.link ? (
                <div className="error">{errors.link}</div>
              ) : null}
            </div>
            <div className={`field`}>
              <label htmlFor="pin">PIN code</label>
              <input
                type='password'
                name="pin"
                id="pin"
                placeholder="Votre code PIN"
                value={values.pin}
                onChange={handleChange}
              />
              {errors.pin && touched.pin ? (
                <div className="error">{errors.pin}</div>
              ) : null}
            </div>
            <button type="submit" disabled={isLoading}>
              {!isLoading && <span>CONFIRMER</span>}
              {/* {isLoading && <span>Sending ...</span>} */}
              <BeatLoader
                color={Constant.spinner_color}
                loading={isLoading}
                cssOverride={{
                  textAlign: 'center',
                  marginTop: '20px'
                }}
              />
              {/* {isLoading && <Loader />} */}
            </button>
          </form>
        )}
        </Formik>
      }
      {
        formSubmitted && 
        <p className='login-info'>
          {message}
        </p>
      }
    </div>
  );
};

export default AdsForm;
